// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Store
import editorStoreConnect from '../../../../components/editor/store/components/editorStoreConnect';
import { getEditorState } from '../../../../components/editor/store/reducers/editorStoreSelector';

// Utils
import getFirstEntityInSelection from '../../../../components/editor/store/reducers/getFirstEntityInSelection';

// Components
import SubToolList from '../SubToolList';
import TableCellFormulaTool from '../tableTools/TableCellFormulaTool';
import AddColumnTool from '../tableTools/AddColumnTool';
import AddRowTool from '../tableTools/AddRowTool';
import CellTypeTool from '../tableTools/CellTypeTool';
import TableCellAlignmentTool from '../tableTools/TableCellAlignmentTool';
import TableCellColorTool from '../tableTools/TableCellColorTool';
import TableEditorToolList from './TableEditorToolList';
import CollapsableTools from '../../collapsableTools/CollapsableTools';
import TextStyleRichTextToolContainer from './textStylesTool/TextStyleRichTextToolContainer';

// Constants
import { TABLE_CELL_EDITOR_KEY } from '../../../../../common/table/tableConstants';

const mapEditorStateToProps = (state) => {
    const editorState = getEditorState(state);

    if (!editorState) return { hasEditorSelection: false };

    const firstEntityKey = getFirstEntityInSelection(editorState);
    const selection = editorState.getSelection();

    if (selection.isCollapsed() && !firstEntityKey) return { hasEditorSelection: false };

    return {
        hasEditorSelection: true,
    };
};

const TABLE_OPERATIONS_TOOLS = {
    RichTextTools: 'RichTextTools',
    CellType: 'CellType',
    TableCellColor: 'TableCellColor',
    TableCellAlignment: 'TableCellAlignment',
    TableCellFormula: 'TableCellFormula',
    AddColumn: 'AddColumn',
    AddRow: 'AddRow',
};

const TABLE_OPERATIONS_COLLAPSIBLE_TOOLS_CONFIG = {
    default: {
        height: { large: 48, medium: 48, small: 43 },
    },
    TableCellAlignment: {
        name: 'Alignment',
        component: TableCellAlignmentTool,
    },
    TableCellFormula: {
        name: 'Formula',
        component: TableCellFormulaTool,
    },
    AddColumn: {
        name: 'Add Column',
        component: AddColumnTool,
    },
    AddRow: {
        name: 'Add Row',
        component: AddRowTool,
    },
    CellType: {
        name: 'Cell Type',
        component: CellTypeTool,
        alwaysVisiblePredicate: () => true,
    },
    TableCellColor: {
        name: 'Cell Color',
        component: TableCellColorTool,
        alwaysVisiblePredicate: () => true,
    },
    RichTextTools: {
        name: 'Text style',
        component: TextStyleRichTextToolContainer,
        alwaysVisiblePredicate: () => true,
    },
};
const TABLE_OPERATIONS_TOOLS_AVAILABLE_COLLAPSIBLE_TOOLS = [
    TABLE_OPERATIONS_TOOLS.RichTextTools,
    TABLE_OPERATIONS_TOOLS.CellType,
    TABLE_OPERATIONS_TOOLS.TableCellColor,
    TABLE_OPERATIONS_TOOLS.TableCellFormula,
    TABLE_OPERATIONS_TOOLS.TableCellAlignment,
    TABLE_OPERATIONS_TOOLS.AddColumn,
    TABLE_OPERATIONS_TOOLS.AddRow,
];

const TABLE_OPERATIONS_COLLAPSE_ORDER = [
    TABLE_OPERATIONS_TOOLS.AddRow,
    TABLE_OPERATIONS_TOOLS.AddColumn,
    TABLE_OPERATIONS_TOOLS.TableCellAlignment,
    TABLE_OPERATIONS_TOOLS.TableCellFormula,
];

const TableOperationsToolList = (props) => {
    const { editorKey, hasEditorSelection, gridSizeName, availableHeight, unavailableHeight } = props;

    const hasTextSelection = editorKey === TABLE_CELL_EDITOR_KEY && hasEditorSelection;

    if (hasTextSelection) return <TableEditorToolList {...props} showSeparators={false} />;

    return (
        <SubToolList {...props}>
            <CollapsableTools
                {...props}
                toolsId="text"
                toolsConfig={TABLE_OPERATIONS_COLLAPSIBLE_TOOLS_CONFIG}
                availableTools={TABLE_OPERATIONS_TOOLS_AVAILABLE_COLLAPSIBLE_TOOLS}
                collapseOrder={TABLE_OPERATIONS_COLLAPSE_ORDER}
                availableHeight={availableHeight}
                gridSizeName={gridSizeName}
                unavailableHeight={unavailableHeight}
            />
        </SubToolList>
    );
};

TableOperationsToolList.propTypes = {
    editorKey: PropTypes.string,
    gridSizeName: PropTypes.string,
    availableHeight: PropTypes.number,
    unavailableHeight: PropTypes.number,
    hasEditorSelection: PropTypes.bool,
};

export default editorStoreConnect(mapEditorStateToProps)(TableOperationsToolList);
